import countryVisit_IFM_UAE from "../../../asset/IFM_UAE.jpg";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;

const ChooseUsImg1 = imageBaseUrl + "ChooseUsImg1.svg";
const ChooseUsImg2 = imageBaseUrl + "ChooseUsImg2.svg";
const ChooseUsImg3 = imageBaseUrl + "ChooseUsImg3.svg";
const universityImg1 = imageBaseUrl + "immersion/RITCampus1.png";
const universityImg2 = imageBaseUrl + "immersion/aitcampus1.png";
const universityImg3 = imageBaseUrl + "immersion/Aivancity_University.webp";
const universityImg4 =
  imageBaseUrl + "immersion/Technical_University_Berlinjpeg.jpeg";
const companyImg1 = imageBaseUrl + "immersion/Siemens_Energy.jpg";
const companyImg2 = imageBaseUrl + "immersion/Meta_AI_Lab.jpeg";
const UTHM_university = imageBaseUrl + "immersion/UTHM.jpg";
const Ai_brain_lab = imageBaseUrl + "immersion/Ai_Brain_Lab.jpg";
const FM_malaysia = imageBaseUrl + "immersion/FM_malaysia.jpg";

const cityCulture1 = imageBaseUrl + "immersion/Dubaiculture1.png";
const cityCulture2 = imageBaseUrl + "immersion/Dubaiculture2.png";
const cityCulture3 = imageBaseUrl + "immersion/Dubaiculture3.png";
const cityCulture4 = imageBaseUrl + "immersion/Dubaiculture4.png";
const cityCulture5 = imageBaseUrl + "immersion/Dubaiculture5.png";
const cityCulture6 = imageBaseUrl + "immersion/Dubaiculture6.png";
const cityCulture11 = imageBaseUrl + "immersion/Malaysia Culture1.png";
const cityCulture22 = imageBaseUrl + "immersion/Malaysia Culture2.png";
const cityCulture33 = imageBaseUrl + "immersion/Malaysia Culture3.png";
const cityCulture44 = imageBaseUrl + "immersion/Malaysia Culture4.png";
const cityCulture55 = imageBaseUrl + "immersion/Malaysia Culture5.png";
const cityCulture66 = imageBaseUrl + "immersion/Malaysia6.png";
const cityCulture111 = imageBaseUrl + "immersion/Thailandsculture1.png";
const cityCulture222 = imageBaseUrl + "immersion/Thailandsculture2.png";
const cityCulture333 = imageBaseUrl + "immersion/Thailandsculture3.png";
const cityCulture444 = imageBaseUrl + "immersion/Thailandsculture4.png";
const cityCulture555 = imageBaseUrl + "immersion/Thailandsculture5.png";
const cityCulture666 =
  imageBaseUrl + "immersion/trees-skyscrapers-distance.jpg";
const cityCulture771 = imageBaseUrl + "immersion/Arc_de_Triomphe.jpg";
const cityCulture772 = imageBaseUrl + "immersion/Eiffel_Tower.jpg";
const cityCulture773 = imageBaseUrl + "immersion/Palace_of_Versailles.jpg";
const cityCulture774 = imageBaseUrl + "immersion/Champ_de_Mars.webp";
const cityCulture775 = imageBaseUrl + "immersion/Grand_Palais.avif";
const cityCulture776 = imageBaseUrl + "immersion/Alexandre_III_bridge.jpg";
const cityCulture881 = imageBaseUrl + "immersion/Brandenburg_Gate.jpg";
const cityCulture882 = imageBaseUrl + "immersion/Sanssouci_Palace.jpg";
const cityCulture883 = imageBaseUrl + "immersion/Miniatur_Wunderland.jpg";
const cityCulture884 = imageBaseUrl + "immersion/The_Romantic_Road.jpeg";
const cityCulture885 = imageBaseUrl + "immersion/The_Holocaust_Memorial.jpeg";
const cityCulture886 =
  imageBaseUrl + "immersion/Memorial_of_the_Berlin_Wall.jpg";

const MiddleEastImmersionUniversity = {
  title: "RIT University",
  image: universityImg1,
  content: {
    university: "Rochester Institute of Technology (RIT)",
    highlights: [
      "#2 in Undergraduate Research – RIT excels in hands-on research opportunities for students.",
      "Top 10 in AI & Robotics – A leader in artificial intelligence and robotics innovation.",
      "#1 for Sustainability Initiatives – Recognized for green campus efforts and eco-friendly innovations.",
      "Career Focused – High job placement and strong industry ties.",
    ],
  },
  companyVisit: {
    image: countryVisit_IFM_UAE,
    // subHeading: "Asian Institute Of Technology",
    points: [
      "Explore Sharjah's hub for new-age companies",
      "Technology & Finance: The Hub of Finance in Dubai",
      "Dubai Electricity & Water Authority and One of the World’s Largest Solar Parks.",
    ],
  },
  testimonialCard: [
    {
      title: "Explore Sharjah's ",
      items: ["Explore Sharjah's hub for new-age companies"],
      Image: ChooseUsImg3,
    },
    {
      title: "Technology & Finance",
      items: ["Technology & Finance: The Hub of Finance in Dubai"],
      Image: ChooseUsImg2,
    },
    {
      title: "Dubai Electricity & Water",
      items: [
        "Dubai Electricity & Water Authority and One of the World’s Largest Solar Parks.",
      ],
      Image: ChooseUsImg1,
    },
  ],
  cityCultureImages: [
    { src: cityCulture1, alt: "Dubai Skyline" },
    { src: cityCulture2, alt: "Dubai Desert" },
    { src: cityCulture3, alt: "Dubai Marina" },
    { src: cityCulture4, alt: "Dubai Skyline" },
    { src: cityCulture5, alt: "Dubai Desert" },
    { src: cityCulture6, alt: "Dubai Marina" },
  ],
};

const SouthEastAsiaImmersionUniversity = [
  {
    title: "UTHM University",
    // image: universityImg2,
    image: UTHM_university,
    content: {
      university: "University Tun Husn Malaysia (UTHM)",
      highlights: [
        "This Malaysia Immersion Program offers students a holistic learning experience.",
      ],
    },
    companyVisit: {
      // image: malaysia_IMU,
      image: FM_malaysia,
      subHeading: "Ministry Of Finance Head Office, Malaysia",
      points: [
        "Explore leading Malaysian industries to understand the application of academic knowledge in fields like finance, healthcare, and technology.",
      ],
    },
    testimonialCard: [
      {
        title: "Explore companies",
        items: ["Explore Sharjah's hub for new-age companies"],
        Image: ChooseUsImg3,
      },
      {
        title: "Technology & Finance",
        items: ["Technology & Finance: The Hub of Finance in Dubai"],
        Image: ChooseUsImg2,
      },
      {
        title: "Dubai Electricity & Water",
        items: [
          "Dubai Electricity & Water Authority and One of the World’s Largest Solar Parks.",
        ],
        Image: ChooseUsImg1,
      },
    ],
    cityCultureImages: [
      { src: cityCulture11, alt: "Dubai Skyline" },
      { src: cityCulture22, alt: "Dubai Desert" },
      { src: cityCulture33, alt: "Dubai Marina" },
      { src: cityCulture44, alt: "Dubai Marina" },
      { src: cityCulture55, alt: "Dubai Marina" },
      { src: cityCulture66, alt: "Dubai Marina" },
    ],
  },
  {
    title: "AIT University",
    image: universityImg2,
    content: {
      university: "Asian Institute of Technology, Pathumthani, Thailand",
      highlights: [
        "26,000+ Alumni from 100+ Countries",
        "QS WUR Ranking by subject is in #51-100 bracket",
        "Ranked #210-300 by Times Higher Education",
      ],
    },
    companyVisit: {
      image: Ai_brain_lab,
      subHeading: "AI Brain Labs",
      points: [
        "Visit to Innovation labs.",
        "Hands-on workshop at the AI Brain Labs.",
      ],
    },
    testimonialCard: [
      {
        title: "Innovation labs",
        items: ["Visit to Innovation labs"],
        Image: ChooseUsImg3,
      },
      {
        title: "Workshop & Labs",
        items: ["Hands-on workshop at the AI Brain Labs"],
        Image: ChooseUsImg2,
      },
    ],
    cityCultureImages: [
      { src: cityCulture111, alt: "Dubai Skyline" },
      { src: cityCulture222, alt: "Dubai Desert" },
      { src: cityCulture333, alt: "Dubai Desert" },
      { src: cityCulture444, alt: "Dubai Marina" },
      { src: cityCulture555, alt: "Dubai Marina" },
      { src: cityCulture666, alt: "Dubai Marina" },
    ],
  },
];

const EuropeImmersionUniversity = [
  {
    title: "ASAI & DS University",
    image: universityImg3,
    content: {
      university:
        "Aivancity, School of Artificial Intelligence and Data Science",
      highlights: [
        "Ranked #1 in AI & Data Science (Eduniversal, 2024), QS Top University - Northern Europe ranking - #158",
        "Awarded Best Pedagogy (1st in Engineering, MSc AI for Business 2nd)",
        "Top 10 Promising Universities in France (Higher Education Review, 2024)",
      ],
    },
    companyVisit: {
      image: companyImg2,
      subHeading: "Meta AI Lab",
      points: [
        "Visit to world renowned companies.",
        "Meta AI Lab /Station- F / CNRS AI Labs / Inria / Dataiku / Meero",
      ],
    },
    testimonialCard: [
      {
        title: "Explore Sharjah's hub for new-age companies",
        items: ["Explore Sharjah's hub for new-age companies"],
        Image: ChooseUsImg3,
      },
      {
        title: "Technology & Finance",
        items: ["Technology & Finance: The Hub of Finance in Dubai"],
        Image: ChooseUsImg2,
      },
      {
        title: "Dubai Electricity & Water",
        items: [
          "Dubai Electricity & Water Authority and One of the World’s Largest Solar Parks.",
        ],
        Image: ChooseUsImg1,
      },
    ],
    cityCultureImages: [
      { src: cityCulture771, alt: "France" },
      { src: cityCulture772, alt: "France" },
      { src: cityCulture773, alt: "France" },
      { src: cityCulture774, alt: "France" },
      { src: cityCulture775, alt: "France" },
      { src: cityCulture776, alt: "France" },
    ],
  },
  {
    title: "Technical University",
    image: universityImg4,
    content: {
      university: "Technical University Berlin",
      highlights: [
        "It is one of the largest technical university",
        "QS World University Rankings 2025: Ranked #147 globally and #8 in Germany",
        "Times Higher Education (THE) Ranking 2024: TU Berlin is ranked #137 globally",
      ],
    },
    companyVisit: {
      image: companyImg1,
      subHeading: "Siemens Energy",
      points: [
        "Visit to world renowned companies.",
        "BMW Factory / Futurium Berlin / Bundestag / Siemens Energy / Aspen",
      ],
    },
    testimonialCard: [
      {
        title: "Explore Sharjah's hub for new-age companies",
        items: ["Explore Sharjah's hub for new-age companies"],
        Image: ChooseUsImg3,
      },
      {
        title: "Technology & Finance",
        items: ["Technology & Finance: The Hub of Finance in Dubai"],
        Image: ChooseUsImg2,
      },
      {
        title: "Dubai Electricity & Water",
        items: [
          "Dubai Electricity & Water Authority and One of the World’s Largest Solar Parks.",
        ],
        Image: ChooseUsImg1,
      },
    ],
    cityCultureImages: [
      { src: cityCulture881, alt: "Germany" },
      { src: cityCulture882, alt: "Germany" },
      { src: cityCulture883, alt: "Germany" },
      { src: cityCulture884, alt: "Germany" },
      { src: cityCulture885, alt: "Germany" },
      { src: cityCulture886, alt: "Germany" },
    ],
  },
];

const NorthAmericaImmersionUniversity = {
  title: "North America",
  image: universityImg1,
  content:
    "Engage with cutting-edge industries and leading institutions in North America.",
  testimonialCard: [
    {
      title: "Explore Sharjah's hub for new-age companies",
      items: ["Explore Sharjah's hub for new-age companies"],
      Image: ChooseUsImg3,
    },
    {
      title: "Technology & Finance",
      items: ["Technology & Finance: The Hub of Finance in Dubai"],
      Image: ChooseUsImg2,
    },
    {
      title: "Dubai Electricity & Water",
      items: [
        "Dubai Electricity & Water Authority and One of the World’s Largest Solar Parks.",
      ],
      Image: ChooseUsImg1,
    },
  ],
  cityCultureImages: [
    { src: cityCulture2, alt: "Dubai Skyline" },
    { src: cityCulture22, alt: "Dubai Skyline" },
    { src: cityCulture222, alt: "Dubai Skyline" },
  ],
};

export {
  MiddleEastImmersionUniversity,
  SouthEastAsiaImmersionUniversity,
  EuropeImmersionUniversity,
  NorthAmericaImmersionUniversity,
};
